import { SortingFn } from "@tanstack/react-table";

export function createEnumSortingFn(enumType: {
  [key: string]: string | number;
}): SortingFn<any> {
  return (rowA, rowB, columnId) => {
    const getValue = (row: any) => {
      const value = row.getIsGrouped()
        ? row.getGroupingValue(columnId)
        : row.getValue(columnId);
      return enumType[value as string] as number;
    };

    return getValue(rowA) - getValue(rowB);
  };
}
